import { useEffect } from "react";

const useScrollToTop = (deps = []) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, deps);
};

export default useScrollToTop;
